var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-base form-section-base"},[_c('v-container',[_c('div',{staticClass:"form-base"},[_c('v-row',[_c('v-col',[_c('div',{staticClass:"form-base__title"},[_vm._v(" Реквизиты счета для возврата должнику безналичных денежных средств, направленных на депонирование ")])])],1),_c('BankDetails',{attrs:{"v":_vm.$v.debtorAccountBankDetails}})],1),_c('Footer',{attrs:{"loading-next":_vm.loadingNext},on:{"prev-btn-click":function () { return _vm.leaveStep({
            stepThis: this$1,
            direction: _vm.StepDirection.PREV,
            step: _vm.StepName.S4,
          }); },"next-btn-click":function () { return _vm.leaveStep({
            stepThis: this$1,
            direction: _vm.StepDirection.NEXT,
            step: _vm.StepName.S4,
          }); }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }